
namespace TabAurous.Common {
    import fld = Production.WIPTransactionRow.Fields;
    @Serenity.Decorators.registerClass()
    export class WIPReceiptMaterialSelectGrid extends _Ext.GridBase<Production.WIPTransactionRow, any> {

        protected getColumnsKey() { return 'Production.DismantlingSelect'; }
        protected getDialogType() { return <any>Production.WIPTransactionDialog; }
        protected getIdProperty() { return Production.WIPTransactionRow.idProperty; }
        protected getLocalTextPrefix() { return Production.WIPTransactionRow.localTextPrefix; }

        protected getService() { return Production.WIPTransactionReceiptMaterialService.baseUrl; }
        protected getInitialTitle() { return null; };
         
        public _bagno: string; 
        private colums: Slick.Column[]

        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            this.colums = columns;
          
            return columns;
        };

        constructor(container: JQuery, options: any) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            //new Serenity.HeaderFiltersMixin({
            //    grid: this
            //});
            var request = this.view.params as ProductRequest;
            if (options.GridFilters.DepartmentId > 0)
                request.DepartmentId = options.GridFilters.DepartmentId;
            if (options.GridFilters.BagNo != "")
                request.BagNo = options.GridFilters.BagNo;

            this.slickGrid.setOptions({ rowHeight: 30 });
            //this.element.height(650);
            this.addQuickFilter({
                type: Retail.TempEditor,
                title: "",
                separator: false,
                field: "ItemTypeId"
            });
            this._bagno = options.GridFilters.BagNo;
            var filteritem = options.GridFilters.FilterItems;
            let propertyName: string = "s-TempEditor s-Retail-TempEditor";
            let radioElement: JQuery = $("[class$='" + propertyName + "']").find("label");

            let radioElement2: JQuery = $("[class$='" + propertyName + "']");
            //J-Jewellery       M-Metal      S-Stone
            if (filteritem == 1 || filteritem == undefined) {//For JMS
                let item1 = radioElement[0];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[1];
                let item3 = radioElement[2];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px; font-weight: normal;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;");

            }
            else if (filteritem == 2) {//For JM
                let item1 = radioElement[0];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[1];
                let item3 = radioElement[2];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px; font-weight: normal;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 3) {//For JS
                let item1 = radioElement[0];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[2];
                let item3 = radioElement[1];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 4) {//For MS
                let item1 = radioElement[1];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[2];
                let item3 = radioElement[0];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 5) {//For J
                let item1 = radioElement[0];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[1];
                let item3 = radioElement[2];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 6) {//For M
                let item1 = radioElement[1];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[0];
                let item3 = radioElement[2];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 7) {//For S
                let item1 = radioElement[2];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[0];
                let item3 = radioElement[1];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            return this;
        }
        protected createToolbarExtensions(): void {
            super.createToolbarExtensions()

        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();

            return grid;
        }
        get selectedItems(): Production.WIPTransactionRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return true; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };



        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            var request = this.view.params as Serenity.ListRequest;
            var itemtype = request.EqualityFilter.ItemTypeId;
            var studded = request.EqualityFilter.Studded;

            this.view.beginUpdate();

            //if (this._bagno != "" && this._bagno != undefined)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria,
            //        [['BagNo'], '=', this._bagno]);
            var self = this;
            let filter = function filter(item, args) {
                var linha = (item as OMS.ProductMasterRow);
                if (itemtype == undefined) {
                    //item["ItemTypeId"] = "101";
                    request.EqualityFilter.ItemTypeId = "101";
                    return true;
                }
                else if (itemtype == "101") {
                    if (item["ItemTypeId"] == "101")
                        return true;
                }
                else if (itemtype == "104") {
                    var cols = self.colums;
                    cols = cols.filter(x => x.field != "SKU" && x.field != "LineNo" && x.field != "CategoryName" && x.field != "SubCategoryName"
                        && x.field != "ItemType" && x.field != "ShapeName" && x.field != "StoneColoreName" && x.field != "SieveName" && x.field != "StoneSizeName" && x.field != "QualityName");
                    self.slickGrid.setColumns(cols);
                    if (item["ItemTypeId"] == "104")
                        return true;
                }
                else if (itemtype == "105") {
                    if (item["ItemTypeId"] == "105")
                        return true;
                }
                return false;
            }

            this.view.setFilter(filter);

            this.view.endUpdate();
            return true;
        }
        //protected onViewSubmit() {
        //    if (!super.onViewSubmit.call(this))
        //        return false;
        //    var request = this.view.params as Serenity.ListRequest;
        //    var x = WorkOrderStockSelectGrid.BagNo;
        //    if (WorkOrderStockSelectGrid.BagNo != "" && WorkOrderStockSelectGrid.BagNo != undefined)
        //        request.Criteria = Serenity.Criteria.and(request.Criteria,
        //            [['BagNo'], '=', WorkOrderStockSelectGrid.BagNo]);

        //    return true;

        //}
    } 
}